import { VNTRANSACTIONS_CLEAR_CARD_DATA, VNTRANSACTIONS_SET_CARD_DATA, VNTRANSACTIONS_SET_ORDER_DATA } from './ActionTypes'

const getInitialState = () => {
  return {
    recovered: null,
    order: null,
  }
}

const reducer = (state = getInitialState(), action) => {
  switch (action.type) {
    case VNTRANSACTIONS_SET_CARD_DATA:
      return {
        ...state,
        recovered: action.data,
      }
    case VNTRANSACTIONS_CLEAR_CARD_DATA:
      return {
        ...state,
        recovered: null,
      }
    case VNTRANSACTIONS_SET_ORDER_DATA:
      return {
        ...state,
        order: action.data,
      }
    default:
      return state
  }
}

export default reducer
